import React from 'react';
import DTQuestionOrInstructionView from '../../DTQuestionOrInstructionView';
import ButtonList from '../../Common/ButtonList/ButtonList';
import Question from '../../Common/Question/Question';

const DTExpertQuestionNode = () => {
  return (
    <DTQuestionOrInstructionView
      titleSection={<Question />}
      options={<ButtonList isButtonDisabled={false} />}
      loading={false}
    />
  );
};

export default DTExpertQuestionNode;
